import React from 'react';
import { Platform, Image } from 'react-native';
import { DataTable } from 'tamagui';
import { View, Text, Title } from '@constants/Themed';
import BlankTrophy from '@assets/--native/BlankTrophy';
import { useTranslation } from 'react-i18next';
import LottieView from '@utils/lottieAnimation';
import { Progress } from 'react-native-web';
import PercentageBar from '@components/Global/PercentageBar';
import { Achievements } from '@components/cards/Achievements/achievementTypes';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';

const achievementHeaders = [
  'Icon', 'Description', 'Category', 'Points', 'ProgressBar'
];

const AchievementTable = ({ achievementList = [{}] }) => {
  const { t } = useTranslation();

  const filteredAchievements = Achievements.map((achievement) => {
    let newAchievement = achievement;
    const matchedAchievement = achievementList.length > 0 && achievementList[0]?._id ? achievementList.find((item) => item?.id === achievement?.id) : null;

    if (matchedAchievement) {
      newAchievement.percentage = 100;
    }

    return newAchievement;
  });

  return (
    <View style={{ flex: 1, borderRadius: 20, elevation: 1 }} pointerEvents='none'>
      {/* <DataTable style={{ borderRadius: 20, backgroundColor: themeSelector() ? '#ececec' : '#333333', overflow: 'hidden' }}>
        <DataTable.Header style={{ backgroundColor: themeSelector() ? 'white' : 'black' }}>
          {achievementHeaders.map((columns, i) => {
            if ((columns === 'Category' || columns === 'Points') && Platform.OS !== 'web') {
              return null;
            }

            return (
              <DataTable.Title textStyle={{ color: themeSelector() ? 'black' : 'white' }} style={columns === 'Description' ? { flex: 3 } : {}} key={i}>
                {columns}
              </DataTable.Title>
            );
          })}
        </DataTable.Header>

        {filteredAchievements.map((columns, i) => (
          <DataTable.Row key={i} style={{ flex: 1 }}>
            <DataTable.Cell style={{ left: -10, flex: 1, maxWidth: 50 }}>
              <Image style={{ width: 40, height: 40, borderRadius: 30 }} source={{ uri: `https://storage.googleapis.com/smartsaas-achievement-image-store/${columns.id}.png` }} />
            </DataTable.Cell>
            <DataTable.Cell style={{ flex: 3 }}>
              <View style={{ backgroundColor: 'transparent' }}>
                <Title style={{ textAlign: 'left', fontSize: 16 }}>{t(`${columns.id}`)}</Title>
                <Text style={{ textAlign: 'left' }}>{columns.description}</Text>
              </View>
            </DataTable.Cell>
            {Platform.OS === 'web' && <DataTable.Cell>{columns.category}</DataTable.Cell>}
            <DataTable.Cell style={{ flex: 1, overflow: 'visible' }}>
              <View style={{ backgroundColor: 'transparent', flex: 1, padding: 5 }}>
                <PercentageBar percentage={columns.percentage || 0} backgroundColor={'#1E90FF'} completedColor={'green'} height={15} style={{ flex: 1, minWidth: 60, overflow: 'visible' }} />
              </View>
            </DataTable.Cell>
          </DataTable.Row>
        ))}
      </DataTable> */}
    </View>
  );
};

export default AchievementTable;
